var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisplayBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.51613 6H4.48387C4.21664 6 4 6.21664 4 6.48387V7.51613C4 7.78336 4.21664 8 4.48387 8H5.51613C5.78336 8 6 7.78336 6 7.51613V6.48387C6 6.21664 5.78336 6 5.51613 6Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51613 3H4.48387C4.21664 3 4 3.21664 4 3.48387V4.51613C4 4.78336 4.21664 5 4.48387 5H5.51613C5.78336 5 6 4.78336 6 4.51613V3.48387C6 3.21664 5.78336 3 5.51613 3Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51613 9H4.48387C4.21664 9 4 9.21664 4 9.48387V10.5161C4 10.7834 4.21664 11 4.48387 11H5.51613C5.78336 11 6 10.7834 6 10.5161V9.48387C6 9.21664 5.78336 9 5.51613 9Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0.666667H2C1.33726 0.666667 0.8 1.11438 0.8 1.66667V13.3333C0.8 13.8856 1.33726 14.3333 2 14.3333H15C15.6627 14.3333 16.2 13.8856 16.2 13.3333V1.66667C16.2 1.11438 15.6627 0.666667 15 0.666667Z",
    stroke: "black",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayBlock);
export default __webpack_public_path__ + "static/media/display-block.c15a85e1b2fab4ecc730204e10be8fc6.svg";
export { ForwardRef as ReactComponent };